import { SearchMode } from '../_types';

// 검색어(URL 쿼리 파라미터) 검증 유틸.
export const MAX_QUERY_LENGTH = 1000;
const VALID_QUERY_PATTERN = /^[a-zA-Z0-9\s,._-]+$/;

/**
 * URL 쿼리 파라미터 검증.
 *
 * Panel 이름은 데이터셋(public/panel_to_genes.json) 기반 값이라 괄호·슬래시·`&`
 * 등이 포함될 수 있으므로(예: `Glaucoma (developmental)`, `PHACE(S) syndrome`)
 * Genes 용 문자 패턴을 강제하지 않는다. 쓰기(triggerSearch)와 읽기(파생)가 같은
 * 기준으로 검증해야 URL round-trip 에서 검색 결과가 사라지지 않는다.
 *
 * @param query URL 의 query 값
 * @param mode 검색 모드 (Genes: 문자 패턴 검증, Panel: 길이만 검증)
 */
export const validateQueryParam = (
  query: string | null,
  mode: SearchMode,
): query is string => {
  if (!query) return false;
  if (query.length > MAX_QUERY_LENGTH) return false;
  if (mode === 'Panel') return true;
  return VALID_QUERY_PATTERN.test(query);
};
